import { AudienceId, EmailMarketingProvider } from "@sp-crm/core";
import { Icon } from "components/icon";
import React from "react";
import { Link } from "react-router-dom";
import { getProviderConfig } from "./audience-provider-utils";

interface AudienceLinkProps {
    audience: { id: AudienceId; name: string } | null;
    emptyLabel?: string;
    provider: EmailMarketingProvider;
}

export const AudienceLink: React.FC<AudienceLinkProps> = props => {
    const { audience, provider } = props;

    const emptyLabel = props.emptyLabel ?? "(deleted contact list)";
    const providerConfig = getProviderConfig(provider);

    if (!audience) return <p>{emptyLabel}</p>;

    return (
        <Link
            to={`${providerConfig.redirectPath}/audiences/${audience.id}`}
            className="inline-block">
            <div className="flex items-center space-x-1">
                <div className="w-4">
                    <Icon name="51_Staff" />
                </div>
                <p>{audience.name}</p>
            </div>
        </Link>
    );
};
